import ActionUtility from '../../utilities/action-utility';

export default class SidebarAction {
  static UPDATE_FILTERS = 'SidebarAction.UPDATE_FILTERS';
  static updateFilters(state) {
    return ActionUtility.createAction(SidebarAction.UPDATE_FILTERS, state);
  }
}
